<template>
  <nav class="bottom-nav d-flex justify-content-around align-items-center">
    <router-link
      v-for="(item, index) in navItems"
      :key="index"
      :to="item.link"
      class="nav-item"
    >
      <i :class="item.icon" class="icon"></i>
      <span class="nav-text">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        { label: 'Shop', icon: 'bi bi-house-door', link: '/search' },
        { label: 'Wishlist', icon: 'bi bi-heart', link: '/wishlist' },
        { label: 'Search', icon: 'bi bi-search', link: '/search' },
        { label: 'Account', icon: 'bi bi-person', link: '/profile' }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 10;
  display: flex;

  .nav-item {
    text-align: center;
    flex: 1;
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease-in-out;
    border: 1px solid #eee;
    padding: 5px 0;

    &:hover {
      color: var(--primary-color);
    }

    .icon {
      font-size: 20px;
      line-height: 22px;
      display: block;
      // margin-bottom: 4px;
    }

    .nav-text {
      font-size: 14px;
      line-height: 16px;
      font-weight: 600;
    }
  }
}
</style>
